import { useQuery } from '@tanstack/react-query'

import type { IPlan } from '@albacross/types'

import { get } from 'utils/http'

export const usePlans = () =>
  useQuery({
    queryKey: ['plans'],
    queryFn: () => get<IPlan[]>('/plans'),
    initialData: [] as IPlan[],
  })
